/* qeslint-disable */

import { LayoutParameters } from "../Settings";
import { Do } from "./do";
import { DataProx } from "./util_datastore_prox";

const packageJson = { version: "test-version" };

interface Listener {
    path: string;
    callback: () => void;
}

interface DataStoreData {
    version: string;
    modified: string;
    title: string;
    ui: {
        currentTime: number;
        totalTime: number;
        scrollTime: number;
        timeScale: number;
    };
    layers: any[];
    [key: string]: any;
}

// Data Store with a source of truth
export class DataStore {
    DELIMITER = ":";
    data?: DataStoreData;
    onOpen: Do;
    onSave: Do;
    listeners: Listener[] = [];

    constructor() {
        this.blank();
        this.onOpen = new Do();
        this.onSave = new Do();
        this.listeners = [];
    }

    addListener(path: string, cb: () => void): void {
        this.listeners.push({
            path: path,
            callback: cb
        });
    }

    blank(): void {
        const data: DataStoreData = {
            version: packageJson.version,
            modified: new Date().toString(),
            title: "Untitled",
            ui: {
                currentTime: 0,
                totalTime: LayoutParameters.DEFAULT_FRAME_LENGTH,
                scrollTime: 0,
                timeScale: LayoutParameters.time_scale
            },
            layers: []
        };

        this.data = data;
    }

    update(): void {
        const data = this.data;

        data!.version = packageJson.version;
        data!.modified = new Date().toString();
    }

    setJSONString(data: string): void {
        this.data = JSON.parse(data);
    }

    /**
     * @param data
     */
    setJSON(data: DataStoreData): void {
        this.data = data;
    }

    getJSONString(format?: number): string {
        return JSON.stringify(this.data, null, format);
    }

    getValue(paths: string): any {
        const descend = paths.split(this.DELIMITER);
        let reference: any = this.data;

        for (let i = 0, il = descend.length; i < il; i++) {
            const path = descend[i];

            if (reference[path] === undefined) {
                console.warn(`Cant find ${paths}`);

                return undefined;
            }

            reference = reference[path];
        }

        return reference;
    }

    setValue(paths: string, value: any): void {
        const descend = paths.split(this.DELIMITER);
        let reference: any = this.data;
        let path: string = "";

        for (let i = 0, il = descend.length - 1; i < il; i++) {
            path = descend[i];
            reference = reference[path];
        }

        path = descend[descend.length - 1];
        reference[path] = value;

        this.listeners.forEach((l) => {
            if (paths.indexOf(l.path) > -1) {
                l.callback();
            }
        });
    }

    get(path: string, suffix?: string): DataProx {
        let fullPath = path;

        if (suffix) {
            fullPath = suffix + this.DELIMITER + path;
        }

        return new DataProx(this, fullPath);
    }
}
